import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useCancelarAgendamento = () => {
  return useMutation({
    mutationFn: (uuid: string) => Agendamento.cancelar({ uuid }),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
